import { styled } from '../../../core/theme/styled';

export const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
`;

type Props = {
  blur: boolean;
};

export const StyledBlur = styled.div<Props>`
  filter: ${(props) => (props.blur ? 'blur(10px)' : '')};
  height: 100%;
  width: 100%;
`;
